import { render, staticRenderFns } from "./bdBMap.vue?vue&type=template&id=57609c54&scoped=true"
import script from "./bdBMap.vue?vue&type=script&lang=js"
export * from "./bdBMap.vue?vue&type=script&lang=js"
import style0 from "./bdBMap.vue?vue&type=style&index=0&id=57609c54&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57609c54",
  null
  
)

export default component.exports